module.exports = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n  <meta charset=\"utf-8\" />\r\n  <title></title>\r\n</head>\r\n<body>\r\n \r\n</body>\r\n</html>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Reports/ReportGenerated.component.html
// module id = ./src/app/Reports/ReportGenerated.component.html
// module chunks = main